import FieldMap from "DashboardBuilder/FieldMap";
import '../styles/Editors.scoped.scss';

export default function SourceSelector({field, sourceSelected}) {
    return <div className="field-editor-row">
        <label className="label">
            Data Source
        </label>
        <div className='field-editor-input'>
            <select
                className="source-selector"
                onChange={(e) => sourceSelected(e.target.value === "" ? null : e.target.value)}
                value={field.source || ''}
                >
                <option key={null} value=''>
                    Select a source
                </option>
                {FieldMap.map((field) => (
                <option key={field.source} value={field.source}>
                {field.label}
                </option>
                ))}
            </select>
        </div>
    </div>
}
